require('react-app-polyfill/ie11');
require('core-js/modules/es.string.ends-with');
require('core-js/modules/es.string.includes');
require('core-js/modules/es.string.starts-with');
